import { createFileRoute, retainSearchParams } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import { PriceApprovalsTabPanel } from "@/screens/Dashboard/components/PriceApprovalsTabPanel"
import { priceApprovalSearchSchema } from "@/screens/Dashboard/schemas"

export const Route = createFileRoute("/app/dashboard/_layout/pending-approvals/_layout/price")({
  validateSearch: zodValidator(priceApprovalSearchSchema),
  search: {
    middlewares: [retainSearchParams(["taskViewScope"])],
  },
  component: () => <PriceApprovalsTabPanel />,
})
